<div
  *ngIf="socials?.length"
  class="social-icons-wrapper"
  [class.large-icons]="iconSize === 'large'"
  [class.medium-icons]="iconSize === 'medium'"
>
  <ng-container *ngFor="let data of socials">
    <ng-container
      *ngIf="
        !truncateData ||
        (truncateData && !data?.logosCount) ||
        (truncateData && data?.logosCount && data?.logosCount <= visibleSocialCount)
      "
    >
      <ng-container
        *ngIf="socialVpn.includes(data.trafficLabelId); else generalSocials"
      >
        <div class="social-icon-container">
          <ng-container
            *ngTemplateOutlet="
              socialTemplate;
              context: {
                data: data
              }
            "
          ></ng-container>
        </div>
      </ng-container>

      <ng-template #generalSocials>
        <ng-container
          *ngIf="
            socialGeneral.includes(data.trafficLabelId);
            else remainingSocials
          "
        >
          <div class="social-icon-container">
            <ng-container
              *ngTemplateOutlet="
                socialTemplate;
                context: {
                  data: data
                }
              "
            ></ng-container>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #remainingSocials>
        <ng-container
          *ngIf="
            socialRemaining.includes(data.trafficLabelId);
            else groupedSocials
          "
        >
          <div class="social-icon-container">
            <ng-container
              *ngTemplateOutlet="
                socialTemplate;
                context: {
                  data: data
                }
              "
            ></ng-container>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #groupedSocials>
        <div class="social-icon-container">
          <ng-container
            *ngTemplateOutlet="
              socialTemplate;
              context: {
                data: data
              }
            "
          ></ng-container>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>

  <!-- More socials icon (eg: "+8") -->
  <ng-container
    *ngIf="truncateData && lastSocialData && lastSocialData['logosCount'] > visibleSocialCount"
  >
    <span class="fa-stack icon-more-social-data">
      <i
        class="fal fa-circle fa-stack-2x"
        [attr.data-social-data-count]="
          lastSocialData['logosCount'] - visibleSocialCount
        "
      ></i>
      <div class="social-count-number">
        +{{ lastSocialData["logosCount"] - visibleSocialCount }}
      </div>
    </span>
  </ng-container>
</div>

<!-- Socials -->
<ng-template let-data="data" #socialTemplate>
  <ng-container [ngSwitch]="data?.iconGroup">
    <ng-container *ngSwitchCase="IconGroupType.GENERAL">
      <i
        nzTooltipPlacement="top"
        nz-tooltip
        [nzTooltipTitle]="GLOBAL_SOCIAL_PREFIX + 'FACEBOOK' | translate"
        [ngClass]="'fab fa-facebook-square'"
      ></i>
      <i
        nzTooltipPlacement="top"
        nz-tooltip
        [nzTooltipTitle]="
          GLOBAL_SOCIAL_PREFIX + 'FACEBOOK_MESSENGER' | translate
        "
        [ngClass]="'fab fa-facebook-messenger'"
      ></i>
      <i
        *ngIf="
          !truncateData ||
          (truncateData && data?.logosCount < visibleSocialCount)
        "
        nzTooltipPlacement="top"
        nz-tooltip
        [nzTooltipTitle]="GLOBAL_SOCIAL_PREFIX + 'TWITTER' | translate"
        [ngClass]="'fab fa-twitter'"
      ></i>
    </ng-container>
    <ng-container *ngSwitchCase="IconGroupType.VPN">
      <img
        [nzTooltipTitle]="GLOBAL_SOCIAL_PREFIX + 'VPN' | translate"
        nzTooltipPlacement="top"
        nz-tooltip
        src="/assets/images/logos/traffic-labels/rappi2.svg"
        [alt]="GLOBAL_SOCIAL_PREFIX + 'VPN' | translate"
        class="social-icon"
      />
    </ng-container>
    <ng-container *ngSwitchCase="IconGroupType.REMAINING">
      <i
        [nzTooltipTitle]="data.trafficLabelId !== 'general' &&
          GLOBAL_SOCIAL_PREFIX + data.trafficLabelId | uppercase | translate
        "
        nzTooltipPlacement="top"
        nz-tooltip
        [ngClass]="'fab fa-' + data.trafficLabelId | lowercase"
      ></i>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <!-- Grouped socials -->
      <i
        [nzTooltipTitle]="data.trafficLabelId !== 'general' &&
          GLOBAL_SOCIAL_PREFIX + data.trafficLabelId | uppercase | translate
        "
        nzTooltipPlacement="top"
        nz-tooltip
        [ngClass]="'fab fa-' + data.trafficLabelId | lowercase"
      ></i>
    </ng-container>
  </ng-container>
  <ng-container
    *ngTemplateOutlet="
      trafficLabelNameTemplate;
      context: {
        $implicit: data.trafficLabelName
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      trafficLabelCapacityTemplate;
      context: {
        $implicit: data.capacity
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      trafficLabelSpeedTemplate;
      context: {
        $implicit: data.speed
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      trafficLabelUsageTemplate;
      context: {
        percent: data.percent,
        capacity: data
      }
    "
  ></ng-container>
</ng-template>

<!-- TrafficLabel properties -->
<ng-template let-name #trafficLabelNameTemplate>
  <span class="social-info social-name" *ngIf="showTrafficName && name">
    {{ name }}
  </span>
</ng-template>

<ng-template let-capacity #trafficLabelCapacityTemplate>
  <ng-container *ngIf="showCapacities">
    <span class="social-info social-capacity">
      <ng-container *ngIf="capacity; else unlimitedCapacityTpl">
        {{
          capacity
            | utils: "convertKibByte"
            | numberFormatter: "'0.0ib'"
            | ibFix
        }}
      </ng-container>
      <ng-template #unlimitedCapacityTpl>
        {{ "FORM.LABEL.UNLIMITED" | translate }}
      </ng-template>
    </span>
  </ng-container>
</ng-template>

<ng-template let-speed #trafficLabelSpeedTemplate>
  <span class="social-info social-speed" *ngIf="showSpeed && speed">
    {{ "GLOBAL_TERMS.PLANS.SPEED." + speed | translate }}
  </span>
</ng-template>

<ng-template let-percent="percent" let-capacity="capacity" #trafficLabelUsageTemplate>
  <span class="social-info social-usage" *ngIf="showUsage">
    <ng-container *ngIf="capacity.hasOwnProperty('unlimited') && capacity.unlimited; else capacityMetrics">
      {{ 'FORM.LABEL.UNLIMITED' | translate }}
    </ng-container>
    <ng-template #capacityMetrics>
      <span
        class="social-metrics"
        [nzTooltipTitle]="tooltipRemaining"
        nzTooltipPlacement="top"
        nz-tooltip
      >
        {{
        capacity.initial
          | utils: "convertKibByte"
          | numberFormatter: "'0.0ib'"
          | ibFix
        }}

        <ng-template #tooltipRemaining>
            {{
          !(capacity.hasOwnProperty('remaining'))
            ?
            (capacity.initial
              | utils: "convertKibByte"
              | numberFormatter: "'0.0ib'"
              | ibFix)
            :
              capacity.remaining
                | utils: "convertKibByte"
                | numberFormatter: "'0.0ib'"
                | ibFix
            }}
            {{ GROUPS_MECTRIC_USAGE_PREFIX + "DATA_REMAINING" | translate }}
        </ng-template>
      </span>
    </ng-template>
  </span>
</ng-template>
